import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  order: -1;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Actions = styled.div`
  position: absolute;
  right: 3%;
  width: ${({ theme }) => theme.spacing.two};
`;

export const ListDate = styled.div`
  background-color: ${({ theme }) => theme.colors.black_5};

  color: ${({ theme }) => theme.colors.black_100};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-stretch: normal;
  font-style: normal;

  padding: 0 0 0.5rem 0;

  &:first-child {
    margin-top: -1px;
  }
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.zero_1};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black_20};
  border-radius: 0.375rem;
  padding: ${({ theme }) => theme.spacing.zero_3};
  margin-bottom: ${({ theme }) => theme.spacing.zero_3};
`;

export const ItemLine = styled.p<{ color?: string; fontWeight?: string; fontFamily?: string }>`
  flex: 1 0 auto;
  color: ${({ color, theme }) => color || theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ fontFamily, theme }) => (fontFamily ? fontFamily : theme.fontFamily.regular)};
  line-height: ${({ theme }) => theme.lineHeight.one_3};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  font-weight: ${({ fontWeight, theme }) => (fontWeight ? fontWeight : theme.fontWeight.medium)};
`;

export const ItemLineBold = styled.span`
  color: ${({ theme }) => theme.colors.black_100};
  font-family: ${({ theme }) => theme.fontFamily.medium};
`;

export const ItemLineInfo = styled.span`
  color: ${({ theme }) => theme.colors.black_80};
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;
